"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.default = {
    isDebug: false,
    setDebug: function () {
        this.isDebug = true;
    },
    log: function () {
        var _a;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        if (this.isDebug) {
            (_a = console.log).call.apply(_a, tslib_1.__spreadArray([window.console, '【Perf】'], rest));
        }
    },
    warn: function () {
        var _a;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        if (this.isDebug) {
            (_a = console.warn).call.apply(_a, tslib_1.__spreadArray([window.console, '【Perf】'], rest));
        }
    },
};
//# sourceMappingURL=logger.js.map